import RestClient from '../../../../api/axiosInterceptor';
import { hospitalDataActions } from '../../../actions/user/hospital/Account/hospitaldata';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function that receives (dispatch, getState).
 */
const createAsyncAction =
	(actionType, apiCall) => async (dispatch, getState) => {
    try {
      // Dispatch the request action before making the API call
      dispatch({ type: actionType.REQUEST });

      // Make the API call and wait for the response
      const response = await apiCall(dispatch, getState);

      // Dispatch the success action with the response data on success
      dispatch({
        type: actionType.SUCCESS,
        payload: response.data // Store the response data
      });
      return response;
    } catch (error) {
      // Dispatch the failure action if an error occurs
      dispatch({
        type: actionType.FAILURE,
        payload: error.response?.data?.message || error.message
      });
    }
	};

/**
 * Retrieves the hospital credentials from Redux state, falling back to localStorage if not present.
 * @param {function} getState - Redux getState function.
 * @returns {string|null} - The credentials string or null if not found.
 */
const getCredentials = (getState) => {
  let credentials = getState().hospitalAuth.credentials;
  if (!credentials) {
    credentials = localStorage.getItem('hospitalCredentials');
  }
  return credentials;
};

// Action creator for fetching hospital data
export const fetchHospitalData = () =>
  createAsyncAction(
    hospitalDataActions.FETCH_PATIENT,
    async (dispatch, getState) => {
      const credentials = getCredentials(getState);
      return RestClient.get('/hospital/hospital-data', {
        headers: {
          Authorization: `Basic ${credentials}`
        }
      });
    }
  );

// Action creator for updating hospital data
export const updateHospitalData = (formData) =>
  createAsyncAction(
    hospitalDataActions.UPDATE_HOSPITAL,
    async (dispatch, getState) => {
      const credentials = getCredentials(getState);
      return RestClient.put('/hospital/hospital-data', formData, {
        headers: {
          Authorization: `Basic ${credentials}`,
          'Content-Type': 'multipart/form-data'
        }
      });
    }
  );
